import styled from 'styled-components';

const H3 = styled.h3`
	margin: 0 0 1.3rem;
	font-size: 2rem;
	font-weight: 700;

	@media (min-width: 1200px) {
		font-size: 3.5rem;
	}
`;

export default H3;
